const IconTask = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.386"
      height="21"
      viewBox="0 0 19.386 21"
    >
      <g data-name="Grupo 11967">
        <path
          data-name="Caminho 12354"
          d="M18 3h-3.18a2.988 2.988 0 0 0-5.64 0H6a2.006 2.006 0 0 0-2 2v15a2.006 2.006 0 0 0 2 2h6.11L10 20H6V5h2v3h8V5h2v7.53l2-1.85V5a2.006 2.006 0 0 0-2-2zm-6 2a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"
          style={{ fill: "#580c81" }}
          transform="translate(-4 -1)"
        />
        <path
          data-name="Icon awesome-check"
          d="M4.555 14.381.2 10.023a.671.671 0 0 1 0-.948l.948-.948a.67.67 0 0 1 .948 0l2.936 2.936 6.288-6.288a.671.671 0 0 1 .948 0l.948.948a.671.671 0 0 1 0 .948L5.5 14.381a.67.67 0 0 1-.945 0z"
          transform="translate(5.977 6.423)"
          style={{ fill: "#580c81" }}
        />
      </g>
    </svg>
  );
};

export default IconTask;
